import { Dealer } from '../types/dealerTypes';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const CHAIRMAN_URL = process.env.REACT_APP_CHAIRMAN_URL!;

const createBasicRoute = (path: string) => ({
  template: path,
  getPath: () => path,
});

export const ROUTES = {
  SUPPORT_DASHBOARD: createBasicRoute('/support-dashboard'),
  SUPPORT_DASHBOARD_NEW_DEALER: createBasicRoute(
    '/support-dashboard/new-dealer',
  ),
  SUPPORT_DASHBOARD_VIEW_DEALER: {
    template: '/support-dashboard/view-dealer/:dealerId',
    getPath: (dealerId: string) => `/support-dashboard/view-dealer/${dealerId}`,
  },
  ADMIN_ACCESS_DEALER: {
    template: '/admin/:dealerId',
    getPath: (dealerId: string) => `/admin/${dealerId}`,
  },
  DEALER_DASHBOARD_HOME: createBasicRoute('/launch/home'),
  DEALER_DASHBOARD_PRODUCT_SELECT: createBasicRoute('/launch/product-select'),
  DEALER_DASHBOARD_ABOUT: createBasicRoute('/launch/about'),
  DEALER_DASHBOARD_ABOUT_INFO: createBasicRoute('/launch/about/info'),
  DEALER_DASHBOARD_ABOUT_CONTACT: createBasicRoute('/launch/about/contact'),
  DEALER_DASHBOARD_INSTORE: createBasicRoute('/launch/instore'),
  DEALER_DASHBOARD_INSTORE_FORMS: createBasicRoute('/launch/instore/forms'),
  DEALER_DASHBOARD_INSTORE_PRINTING_SETUP: createBasicRoute(
    '/launch/instore/printing',
  ),
  DEALER_DASHBOARD_USERS: createBasicRoute('/launch/users'),
  DEALER_DASHBOARD_USERS_ADD: createBasicRoute('/launch/users/addusers'),
  DEALER_DASHBOARD_ONLINE: createBasicRoute('/launch/online'),
  DEALER_DASHBOARD_ONLINE_PICKUP_DELIVERY: createBasicRoute(
    '/launch/online/pickup-delivery',
  ),
  DEALER_DASHBOARD_ONLINE_WIDGETS: createBasicRoute('/launch/online/widgets'),
  DEALER_DASHBOARD_ONLINE_VIRTUAL_SHOWROOM: createBasicRoute(
    '/launch/online/virtual-showroom',
  ),
  DEALER_DASHBOARD_INTEGRATIONS: createBasicRoute('/launch/integrations'),
  DEALER_DASHBOARD_INTEGRATIONS_INVENTORY: createBasicRoute(
    '/launch/integrations/inventory',
  ),
  DEALER_DASHBOARD_INTEGRATIONS_CRM: createBasicRoute(
    '/launch/integrations/crm',
  ),
  DEALER_DASHBOARD_INTEGRATIONS_FNI: createBasicRoute(
    '/launch/integrations/fni',
  ),
  DEALER_DASHBOARD_INTEGRATIONS_DEALER_MANAGEMENT: createBasicRoute(
    '/launch/integrations/dealer-management',
  ),
  DEALER_DASHBOARD_INTEGRATIONS_TRADEIN_MANAGER: createBasicRoute(
    '/launch/integrations/tradein-manager',
  ),
  DEALER_DASHBOARD_LENDING: createBasicRoute('/launch/lending'),
  DEALER_DASHBOARD_LENDING_PROMO: createBasicRoute('/launch/lending/promo'),
  DEALER_DASHBOARD_LENDING_BUSINESS: createBasicRoute(
    '/launch/lending/business',
  ),
  DEALER_DASHBOARD_LENDING_FINANCE_CONTACT: createBasicRoute(
    '/launch/lending/finance-contact',
  ),
  DEALER_DASHBOARD_LENDING_FINANCE_HOURS: createBasicRoute(
    '/launch/lending/finance-hours',
  ),
  DEALER_DASHBOARD_LENDING_PAYMENT: createBasicRoute('/launch/lending/payment'),
  DEALER_DASHBOARD_LENDING_NEXT: createBasicRoute('/launch/lending/next-steps'),
  DEALER_DASHBOARD_PRICING: createBasicRoute('/launch/pricing'),
  DEALER_DASHBOARD_PRICING_FEES: createBasicRoute('/launch/pricing/fees'),
  DEALER_DASHBOARD_PRICING_SOURCE: createBasicRoute('/launch/pricing/source'),
  DEALER_DASHBOARD_PRICING_PAYMENT_CONFIGURATION: createBasicRoute(
    '/launch/pricing/payment-configuration',
  ),
  DEALER_DASHBOARD_PRICING_CREDIT: createBasicRoute('/launch/pricing/credit'),
  DEALER_DASHBOARD_PRICING_FINANCE_RATES: createBasicRoute(
    '/launch/pricing/finance-rates',
  ),
  DEALER_DASHBOARD_PRICING_LEASE_RATES: createBasicRoute(
    '/launch/pricing/lease-rates',
  ),
  DEALER_DASHBOARD_PRICING_VALIDATION: createBasicRoute(
    '/launch/review-validation/pricing-new',
  ),
  DEALER_DASHBOARD_PRICING_VALIDATION_USED: createBasicRoute(
    '/launch/review-validation/pricing-used',
  ),
  DEALER_REVIEW_VALIDATION: createBasicRoute('/launch/review-validation'),
  DEALER_DASHBOARD_REVIEW: createBasicRoute('/launch/review'),
};

/**
 * Creates a chairman url builder from a template string
 * The builder replaces :dealerId in the template with dealer.id
 */
const buildChairmanUrl = (template: string) => (dealer: Dealer) =>
  `${CHAIRMAN_URL}${template.replace(':dealerId', dealer.id)}`;

/**
 * Chairman routes
 */
export const CHAIRMAN_ROUTES = {
  DEALER_EDITOR_SPECIFICATIONS: buildChairmanUrl('/dealer/:dealerId/1'),
  DEALER_EDITOR_INVENTORY: buildChairmanUrl('/dealer/:dealerId/3'),
  DEALER_EDITOR_INTEGRATIONS: buildChairmanUrl('/dealer/:dealerId/4'),
  DEALER_EDITOR_FEES: buildChairmanUrl('/dealer/:dealerId/6'),
  DEALER_EDITOR_CONFIGURATION: buildChairmanUrl('/dealer/:dealerId/7'),
  DEALER_PRICING_EDITOR_PRICING: buildChairmanUrl('/:dealerId/pricing/1'),
  DEALER_PRICING_EDITOR_TAXES_AND_ADDONS: buildChairmanUrl(
    '/:dealerId/pricing/3',
  ),
  DEALER_PRICING_EDITOR_ONLINE_APR_CONFIG: buildChairmanUrl(
    '/:dealerId/pricing/4',
  ),
  DEALER_WIDGETS: buildChairmanUrl('/:dealerId/buttons'),
  DEALER_USERS: buildChairmanUrl('/:dealerId/users'),
};
